/* eslint-disable import/no-cycle */
// This file is a workaround to prevent circular dependencies.
// source:
//   https://vuex-orm.org/guide/model/single-table-inheritance.html#solution-how-to-break-cycles

export * from "./Action";

export * from "./BrowserAction";
export * from "./Click";
export * from "./Input";
export * from "./Keypress";
export * from "./BrowserPlayback";
export * from "./Scroll";

export * from "./Pause";
export * from "./Overlay";

export * from "./Slide";
export * from "./FileSlide";
export * from "./ImageSlide";
export * from "./TextSlide";
export * from "./VideoSlide";
export * from "./LinkedVideoSlide";

// needs to be after all the exports for circular dependency reasons
// eslint-disable-next-line import/first
import { Action } from "./Action";
// eslint-disable-next-line import/first
import { BrowserAction } from "./BrowserAction";
// eslint-disable-next-line import/first
import { BrowserPlayback } from "./BrowserPlayback";

// babel-plugin-rewire-exports has issues with this file if it doesn't contain some sort of `export const`
export const BrowserActionTypes = (): string[] => Object.keys(BrowserAction.types());
